import React from 'react';
import { TableHead, TableRow } from '@/components/ui/table';
import { Checkbox } from '@/components/ui/checkbox';
import type { CheckedState } from '@radix-ui/react-checkbox';

interface PortfolioTableHeaderProps {
  headerChecked: CheckedState;
  onToggleAll: () => void;
  onSort: (field: 'name' | 'type' | 'total') => void;
  renderSortIcon: (field: 'name' | 'type' | 'total') => React.ReactNode;
}

export const PortfolioTableHeader: React.FC<PortfolioTableHeaderProps> = ({
  headerChecked,
  onToggleAll,
  onSort,
  renderSortIcon,
}) => {
  return (
    <TableRow>
      <TableHead className="h-8 w-[40px] min-w-[40px] pl-4 pr-2 py-1 text-left text-muted-foreground text-xs font-normal sticky z-10">
        <div className="flex items-center justify-center">
          <Checkbox
            checked={headerChecked}
            onCheckedChange={onToggleAll}
            aria-label="Select all on page"
            className="h-3.5 w-3.5"
          />
        </div>
      </TableHead>
      <TableHead
        className="h-8 px-3 py-1 text-left text-muted-foreground text-xs font-normal select-none cursor-pointer whitespace-nowrap"
        onClick={() => onSort('name')}
      >
        <div className="flex items-center gap-1">
          <span>Portfolio</span>
          {renderSortIcon('name')}
        </div>
      </TableHead>
      <TableHead
        className="h-8 px-3 py-1 text-left text-muted-foreground text-xs font-normal select-none cursor-pointer whitespace-nowrap"
        onClick={() => onSort('type')}
      >
        <div className="flex items-center gap-1">
          <span>Type</span>
          {renderSortIcon('type')}
        </div>
      </TableHead>
      <TableHead className="h-8 w-[44px] min-w-[44px] px-2 py-1 text-center text-muted-foreground text-xs font-normal whitespace-nowrap">
        <span className="sr-only">Status</span>
      </TableHead>
      <TableHead className="h-8 px-2 py-1 text-right text-muted-foreground text-xs font-normal whitespace-nowrap">Equity</TableHead>
      <TableHead className="h-8 px-2 py-1 text-right text-muted-foreground text-xs font-normal whitespace-nowrap">Income</TableHead>
      <TableHead className="h-8 px-2 py-1 text-right text-muted-foreground text-xs font-normal whitespace-nowrap">Cash</TableHead>
      <TableHead className="h-8 px-2 py-1 text-right text-muted-foreground text-xs font-normal whitespace-nowrap">Alternative</TableHead>
      <TableHead className="h-8 px-2 py-1 text-right text-muted-foreground text-xs font-normal whitespace-nowrap">Multi-Asset</TableHead>
      <TableHead
        className="h-8 px-2 py-1 text-right text-muted-foreground text-xs font-normal select-none cursor-pointer whitespace-nowrap"
        onClick={() => onSort('total')}
      >
        <div className="flex items-center gap-1 justify-end">
          <span>Total</span>
          {renderSortIcon('total')}
        </div>
      </TableHead>
    </TableRow>
  );
};
